<template>
  <div :class="['archive', { collapse, collapsed }]">
    <Icon art="light" name="spinner" spin v-if="archivedLoading"/>
    <div v-if="isArchiveView">
      <ArchiveConversationDetails :conversation="selectedArchived" />
    </div>
    <template v-else>
      <button
        v-if="collapse"
        class="collapse-toggle"
        @click="collapsed = !collapsed"
      >
        <Icon
          class="chevron"
          art="regular"
          :height="13"
          name="chevron-right"
          color="gray"
        />
        {{ t('archive_chat_list_title') }}
      </button>
      <div class="archived-conversations-sep" />
      <div class="archived-conversations">
        <div
          v-for="(conversation, index) in archived"
          :key="index"
          class="archived-conversations-item"
          @click="onSelect(conversation)">
            <div>
              <span class="left">{{ conversation.lastActiveAgent }}</span>
              <span class="right">{{ formatDate(conversation.created) }}</span>
            </div>
            <p class="message-text">
              <small>{{ getFirstMessage(conversation.firstMessage) }}</small>
            </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { formatDate } from '@/helpers/helpers'
import Icon from '../Icon'
import ArchiveConversationDetails from './ArchivedConversationDetails'

export default {
  name: 'ArchivedConversationsList',
  
  components: {
    ArchiveConversationDetails,
    Icon
  },
  
  props: [],
  
  setup () {
    const { $label: t } = useI36n()

    const aiaiBotDefaultMessage = t.value('aiaibot_archive_first_message')

    const getFirstMessage = message => {
      return ['aiaibot_inactive_close', 'AIAIBOT_FEEDBACK']
        .includes(message.trim())
          ? aiaiBotDefaultMessage
          : message
    }

    return { t, getFirstMessage }
  },

  data () {
    return {
      selectedConversation: {},
      collapsed: true
    }
  },

  computed: {
    ...mapGetters('uistate', ['isArchiveView']),
    ...mapState('conversation', ['archived', 'archivedLoading', 'selectedArchived']),

    collapse () {
      return (
        process.env.VUE_APP_COLLAPSE_ARCHIVES &&
        !this.isArchiveView &&
        this.archived.length
      )
    },
  },

  created () {
    this.setArchived()
  },
  
  methods: {
    ...mapActions('conversation', ['setArchived', 'setSelectedArchived']),
    ...mapActions('uistate', ['setArchiveView']),
    
    formatDate,
    
    onSelect (conversation) {
      this.setSelectedArchived(conversation)
      this.setArchiveView(true)
    },
  }
}
</script>

<style scoped lang="postcss">
  .archive-spinner {
    margin: auto;
  }

  .archive.collapse {
    position: relative;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: -20px;
      right: -20px;
      bottom: 0;
      box-shadow: 0 0 10px rgba(0,0,0, 0.1) inset;
      pointer-events: none;
      user-select: none;
    }

    .collapse-toggle {
      width: 100%;
      margin: 0;
      padding: 10px;
      text-align: left;
      color: var(--tw-c-dark-gray);
      background: rgba(255,255,255, 0.4);
      border: none;
      cursor: pointer;

      .chevron {
        transform: rotate(90deg);
        transition: transform 0.2s ease-out;
      }
    }

    .archived-conversations-sep {
      height: 1px;
      background: var(--tw-c-light-gray);
      opacity: 0.5;
    }

    .archived-conversations {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 360px;
      overflow: auto;
      background: rgba(255,255,255, 0.4);
      transition: height 0.2s linear;
    }

    &.collapsed {
      .archived-conversations {
        height: 0;
        overflow: hidden;
      }
      .chevron {
        transform: rotate(0);
      }
    }
  }

  .archived-conversations-item {
    display: grid;
    margin: 10px;
    padding: 10px;
    cursor: pointer;
    background-color: var(--tw-c-white);

    .left {
      float: left;
    }

    .right {
      float: right;
    }

    .message-text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
      color: var(--tw-c-cool-gray);
      font-size: 13px;
    }
  }
</style>
